export default "/images/vendor/@coreui/icons/svg/flag/cif-bo.svg?532cdebefdb385a64923d0c795a58d51";